import React, { useState, useEffect } from 'react'
import { Col, Input, Row } from 'antd'
import { FaStar, FaTimes } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { applyFilters, setSelectedRatings, setSelectedLocation, setPriceRange, setSortOrder, clearAllFilters, setSearchQuery } from '../../../redux/hotel/hotelFilterSlice';
import Slider from 'rc-slider';

const HotelResultFilter = ({ hotelsToDisplay, setIsVisibleMobile }) => {
    const dispatch = useDispatch();


    const [isMobile, setIsMobile] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const filteredData = useSelector(state => state?.hotelFilter?.filteredData);
    const selectedRatings = useSelector(state => state?.hotelFilter?.selectedRatings);
    const selectedLocation = useSelector(state => state?.hotelFilter?.selectedLocation);
    const priceRange = useSelector(state => state?.hotelFilter?.priceRange);
    const defaultPriceRange = useSelector(state => state?.hotelFilter?.defaultPriceRange);
    const sortOrder = useSelector(state => state?.hotelFilter?.sortOrder);
    const searchQuery = useSelector(state => state?.hotelFilter?.searchQuery);

    const allHotelList = useSelector(state => state.hotelData.allHotelList);
    const minPrice = allHotelList?.priceRange?.minPrice;
    const maxPrice = allHotelList?.priceRange?.maxPrice;

    const handleSelectLocation = (location) => {
        const updatedLocations = selectedLocation?.includes(location)
            ? selectedLocation.filter((item) => item !== location)
            : [...selectedLocation, location];

        dispatch(setSelectedLocation(updatedLocations));
    };


    const handlePriceChange = (newValue) => {
        dispatch(setPriceRange(newValue));
    };

    useEffect(() => {
        if (allHotelList) {
            const minPrice = allHotelList?.priceRange?.minPrice || 0;
            const maxPrice = allHotelList?.priceRange?.maxPrice || 100;
            // Set the initial price range from API data
            // dispatch(setDefaultPriceRange([minPrice, maxPrice]));
            dispatch(setPriceRange([minPrice, maxPrice]));
        }
    }, [allHotelList, dispatch]);



    const handleCheckboxRatingChange = (rating) => {
        dispatch(setSelectedRatings(
            selectedRatings.includes(rating)
                ? selectedRatings.filter(r => r !== rating)
                : [...selectedRatings, rating]
        ));
    };

    const handlePriceOrderASCDSC = (newSortOrder) => {
        dispatch(setSortOrder(newSortOrder));
    };


    useEffect(() => {
        handlePriceOrderASCDSC('asc')
    }, []);

    useEffect(() => {
        if (allHotelList) {
            dispatch(applyFilters({ allHotelList }));
        }
    }, [selectedRatings, priceRange, sortOrder, selectedLocation, dispatch, allHotelList]);



    const handleClearFilters = () => {
        dispatch(clearAllFilters({ allHotelList }));
    };

    const handleSearchChange = (e) => {
        const query = e.target.value;
        dispatch(setSearchQuery(query));
        dispatch(applyFilters({ allHotelList }));
    };


    return (
        <>
            {allHotelList?.hotels?.length !== 0 &&
                <div className="MobilefilterSearchcard hotel-filter filterSearchcard bg-white rounded-3  mb-3 mb-md-4">
                    <div className="filter-searchBar-head border-bottom w-100">
                        <div className="searchBar-headerBody d-flex align-items-center justify-content-between px-3 py-3">
                            <button onClick={() => setIsVisibleMobile(false)} className='btn btn-light-primary border-0 rounded d-flex align-items-center p-1 d-md-none' aria-label="close filter">
                                <FaTimes className='fs-3 text-primary' />
                            </button>
                            <div className="searchBar-headerfirst text-left">
                                <h6 className="fw-bold fs-5 m-0">Filters</h6>
                                <p className="text-md text-muted m-0">Showing {hotelsToDisplay?.length} Hotels</p>
                            </div>
                            <div className="searchBar-headerlast text-end d-flex gap-1">
                                <button className="btn btn-danger py-0 rounded read-more-button text-decoration-none" onClick={handleClearFilters} aria-label="clear all">Clear All</button>
                            </div>
                        </div>
                    </div>


                    <div className="filter-searchBar-body">

                        <div className="searchBar-single px-3 py-3 border-bottom">
                            <div className="searchBar-single-title mb-3">
                                <h6 className="sidebar-subTitle fs-6 fw-medium m-0 mb-2">Pricing Range in (₹)</h6>
                                <div style={{ lineHeight: "14px" }} className='bg-light p-1 rounded'>
                                    <small>Price per room per night (excl. taxes, & charges).</small>
                                </div>
                            </div>
                            <div className="price-range-slider">
                                <div>
                                    <Slider
                                        range
                                        min={minPrice}
                                        max={maxPrice}
                                        step={Math.ceil((priceRange?.[0] - priceRange?.[1]) / 100)}
                                        onChange={handlePriceChange}
                                        value={priceRange}
                                        ariaLabelForHandle={['Minimum price slider', 'Maximum price slider']}
                                        ariaValueTextFormatterGroup={val => `₹${val}`}
                                    />
                                    <div className='price_box mt-3 mb-2 d-flex gap-2 align-items-center'>
                                        <div>
                                            <label id='minlabel'>Min Price</label>
                                            <p>₹{Math.round(priceRange[0]) ? Math.round(priceRange[0]) : 0}</p>
                                        </div>
                                        <div>
                                            <label id='maxlabel'>Max Price</label>
                                            <p>₹{Math.round(priceRange[1]) ? Math.round(priceRange[1]) : 0}</p>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div className="searchBar-single px-3 py-3 border-bottom">
                            <div className="searchBar-single-title d-flex mb-3">
                                <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Sort By Price:</h6>
                            </div>
                            <div className="searchBar-single-wrap">
                                <div className="d-flex gap-2">
                                    <div className='w-100'>
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            id="Low"
                                            checked={sortOrder === 'asc'}
                                            onChange={() => handlePriceOrderASCDSC('asc')}
                                        />
                                        <label className="btn btn-sm btn-secondary rounded-1 fw-medium full-width" htmlFor="Low">
                                            Low to High
                                        </label>
                                    </div>
                                    <div className='w-100'>
                                        <input
                                            type="radio"
                                            className="btn-check"
                                            id="High"
                                            checked={sortOrder === 'desc'}
                                            onChange={() => handlePriceOrderASCDSC('desc')}
                                        />
                                        <label className="btn btn-sm btn-secondary rounded-1 fw-medium full-width" htmlFor="High">
                                            High to Low
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="searchBar-single px-3 py-3 border-bottom">
                            <div className="searchBar-single-title d-flex mb-3">
                                <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Star Rating</h6>
                            </div>
                            <div className="searchBar-single-wrap">
                                <Row gutter={16}>
                                    <Col xs={24}>
                                        <div className='d-flex gap-2 '>
                                            <div className='w-100 text-center'>
                                                <input
                                                    type="checkbox"
                                                    className="btn-check"
                                                    id="2star"
                                                    onChange={() => handleCheckboxRatingChange(2)}
                                                    checked={selectedRatings.includes(2)}
                                                />
                                                <label className="btn btn-sm btn-secondary rounded-1 fw-medium full-width" htmlFor="2star">
                                                    <span className="d-flex align-items-center"><b style={{ fontSize: "8px", marginRight: "2px" }}>&#x276E;</b> 2</span><FaStar />
                                                </label>
                                            </div>
                                            <div className='w-100 text-center'>
                                                <input
                                                    type="checkbox"
                                                    className="btn-check"
                                                    id="3star"
                                                    onChange={() => handleCheckboxRatingChange(3)}
                                                    checked={selectedRatings.includes(3)}
                                                />
                                                <label className="btn btn-sm btn-secondary rounded-1 fw-medium full-width" htmlFor="3star">3<FaStar /></label>
                                            </div>
                                            <div className='w-100 text-center'>
                                                <input
                                                    type="checkbox"
                                                    className="btn-check"
                                                    id="4star"
                                                    onChange={() => handleCheckboxRatingChange(4)}
                                                    checked={selectedRatings.includes(4)}
                                                />
                                                <label className="btn btn-sm btn-secondary rounded-1 fw-medium full-width" htmlFor="4star">4<FaStar /></label>
                                            </div>
                                            <div className='w-100 text-center'>
                                                <input
                                                    type="checkbox"
                                                    className="btn-check"
                                                    id="5star"
                                                    onChange={() => handleCheckboxRatingChange(5)}
                                                    checked={selectedRatings.includes(5)}
                                                />
                                                <label className="btn btn-sm btn-secondary rounded-1 fw-medium full-width" htmlFor="5star">5<FaStar /></label>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>

                        <div className="searchBar-single px-3 py-3">
                            <div className="searchBar-single-title d-flex align-items-center justify-content-between">
                                <h6 className="sidebar-subTitle fs-6 fw-medium m-0">Search Hotel By Name</h6>
                            </div>
                            <div className="searchBar-single-wrap">
                                <Row gutter={16} className="align-items-center justify-content-between">
                                   
                                    <Col xs={24} className='pt-2 pb-3'>
                                        <Input
                                            placeholder="Search Hotel By Name"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                            style={{height: '45px', fontSize: '16px'}}
                                        />
                                    </Col>
                                </Row>
                            </div>
                        </div>

                        <div className="d-md-none px-3 text-end mb-3">
                            <button onClick={() => setIsVisibleMobile(false)} className='w-100 py-3 btn btn-primary border-0 rounded text-decoration-none fs-5' aria-label="Apply">
                                Apply
                            </button>
                        </div>

                    </div>



                </div>
            }
        </>
    )
}

export default HotelResultFilter
